/**
 * Константы для работы с клиентами
 */

import { ClientSex } from '@shared/api/graphql/gql/graphql';

export { ClientConsentKind, ClientType, ScenarioRunStatus } from '@shared/api/graphql/gql/graphql';

/**
 * Уровни важности клиента
 */
export enum ClientImportance {
  VIP = 'vip',
  REGULAR = 'regular',
}

const clientImportanceLabels: Readonly<Record<string, string>> = {
  [ClientImportance.VIP]: 'VIP',
  [ClientImportance.REGULAR]: 'Обычный',
};

/**
 * Проверить, является ли клиент VIP
 */
export const isVipClient = (importance: string | undefined): boolean => {
  return importance === ClientImportance.VIP;
};

/**
 * Получить локализованное название уровня важности клиента
 */
export const getClientImportanceLabel = (importance: string): string => {
  return clientImportanceLabels[importance] ?? 'Обычный';
};

/**
 * Опции для селекта уровней важности клиентов
 */
export interface ClientImportanceOption {
  [key: string]: unknown;
  label: string;
  value: ClientImportance;
}

/**
 * Получить опции для селекта уровней важности клиентов
 */
export const getClientImportanceOptions = (): ClientImportanceOption[] => {
  return [
    {
      value: ClientImportance.REGULAR,
      label: getClientImportanceLabel(ClientImportance.REGULAR),
    },
    {
      value: ClientImportance.VIP,
      label: getClientImportanceLabel(ClientImportance.VIP),
    },
  ];
};

const clientSexLabels: Readonly<Record<ClientSex, string>> = {
  [ClientSex.Male]: 'Мужской',
  [ClientSex.Female]: 'Женский',
};

/**
 * Получить локализованное название пола клиента
 */
export const getClientGenderLabel = (sex: ClientSex | null): string => (sex ? clientSexLabels[sex] : 'Не указан');

/**
 * Опции для селекта пола клиентов
 */
export interface ClientGenderOption {
  [key: string]: unknown;
  label: string;
  value: ClientSex | null;
}

/**
 * Получить опции для селекта пола клиентов
 */
export const getClientGenderOptions = (): ClientGenderOption[] => {
  return [
    { value: null, label: getClientGenderLabel(null) },
    {
      value: ClientSex.Male,
      label: getClientGenderLabel(ClientSex.Male),
    },
    {
      value: ClientSex.Female,
      label: getClientGenderLabel(ClientSex.Female),
    },
  ];
};
